"use client";

import { useId, useState } from "react";
import { cn } from "@/lib/utils";

type FAQ = { question: string; answer: string };
type FAQItemProps = { item: FAQ; defaultOpen?: boolean; className?: string };

export function FAQItem({ item, defaultOpen = false, className }: FAQItemProps) {
    const [open, setOpen] = useState(defaultOpen);
    const btnId = useId();
    const panelId = `${btnId}-panel`;

    return (
        <div className={cn("w-full border-b border-black/20 py-[34px]", className)}>
            <h3 className="text-left">
                <button
                id={btnId}
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => setOpen((v) => !v)}
                className={cn(
                    "flex w-full items-center gap-4 text-left outline-none",
                    "text-white hover:text-white/90 focus-visible:ring-2 focus-visible:ring-white/30 rounded-md"
                )}
                >
                    {/* Plus/Minus icon */}
                    <span
                        aria-hidden="true"
                        className={cn(
                        "relative inline-flex h-5 w-5 items-center justify-center rounded-full",
                        open ? "text-[#202020]" : "text-[#202020]"
                        )}
                    >
                        {/* horizontal bar */}
                        <span className="block h-[2px] w-3.5 bg-current" />
                        {/* vertical bar, scales to 0 when open */}
                        <span
                        className={cn(
                            "absolute h-3.5 w-[2px] bg-current transition-transform duration-200 ease-out",
                            open ? "scale-y-0" : "scale-y-100"
                        )}
                        />
                    </span>
                    <span className={cn("text-xl max-sm:text-base tracking-[0.5px]", open ? "text-[#202020]" : "text-[#202020]")}>
                        {item.question}
                    </span>
                </button>
            </h3>

            <div
                id={panelId}
                role="region"
                aria-labelledby={btnId}
                className={cn(
                "grid transition-[grid-template-rows,opacity] duration-300 ease-out",
                open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                )}
            >
                <div className="overflow-hidden">
                <div className="text-base font-light text-[#646464] mt-3 ml-9 whitespace-pre-line">{item.answer}</div>
                </div>
            </div>
        </div>
    );
}
